export enum LabelType {
	Error = "error",
	Warning = "warning",
	Success = "success",
	Neutral = "neutral",
}
